import { createReducer, on } from '@ngrx/store';
import { setScatterPlot } from '../scatter-plot.actions';
import { setPresentationOption } from './presentation-options.actions';
import { ScatterPlotChartSize, ScatterPlotPresentationOptionValue } from 'ChartApp/ts/enums/scatter-plot-common.enum';
export const size = createReducer(ScatterPlotChartSize.basic_2000, on(setPresentationOption, (state, action) => {
    if (action.option === ScatterPlotPresentationOptionValue.size) {
        return action.value;
    }
    return state;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.size;
}));
